// frontend/src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import styles from './Login.module.css';
import { useTranslation } from 'react-i18next';
import quironLogo from '../assets/quiron-isotipo.png';

function Login({ setIsLoggedIn }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.setAttribute('data-force-theme', 'dark');
    return () => {
      document.documentElement.removeAttribute('data-force-theme');
    };
  }, []);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { setUser } = useUser();

  const API_URL = process.env.REACT_APP_API_URL || 'https://quiron.app/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError(t('passwordMinLength'));
      return;
    }
    setIsLoading(true);
    try {
      const formBody = new URLSearchParams();
      formBody.append('username', email);
      formBody.append('password', password);

      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody,
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('authToken', data.access_token);
        setUser(data.user);
        setIsLoggedIn(true);
        navigate('/consultation-manager');
      } else {
        const errorData = await response.json();
        setError(errorData.detail || errorData.error || t('invalidCredentials'));
      }
    } catch (error) {
      console.error(t('errorLoggingIn'), error);
      setError(t('serverConnectionError'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.authPageWrapper}>
      <div className={styles.logoContainer} onClick={() => navigate('/')}>
        <img src={quironLogo} alt="Quiron Logo" className={styles.logoImg} />
        <h1 className={styles.logoText}>Quiron</h1>
      </div>

      <div className={styles.formContainer}>
        <h2 className={styles.formTitle}>{t('login')}</h2>
        <form onSubmit={handleSubmit}>
          <div>
            <label className={styles.themeLabel}>{t('email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.themeInput}
              autoComplete="username"
            />
          </div>
          <div>
            <label className={styles.themeLabel}>{t('password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.themeInput}
              autoComplete="current-password"
            />
            <p className={styles.registerMessage}>
              {t('noAccountYet')}{' '}
              <a href="/register" className={styles.registerLink}>{t('registerNow')}</a>
            </p>
          </div>
          {error && <p className={styles.errorMessage}>{error}</p>}
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button type="submit" className={styles.themeButton} disabled={isLoading}>
              {isLoading ? t('loggingIn') : t('loginButton')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;